<template lang="pug">
  div(:class="b({ inline })")
    div(:class="b('container')")
      item(
        v-for="item in items"
        :key="item.value"
        :selected="isSelected(getItemValue(item))"
        :item="item"
        @click="onClickItem"
      )
    .v-messages.error--text(v-if="errorMessages")
      .v-messages__message(v-for="error in Array.isArray(errorMessages) ? errorMessages : [errorMessages]" :key="error") {{ error }}
</template>

<script>
  import $ from 'jquery';
  import Item from './choices-item';

  export default {
    name: 'choices',

    props: {
      value: { type: [Object, Number, String, Array] },
      multiple: { type: Boolean, default: false },
      inline: { type: Boolean, default: false },
      itemValue: { type: String },
      items: {
        type: Array,
        default: () => [],
      },
      errorMessages: { type: [Array, String] },
      name: { type: String },
      scrollOnSelect: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false },
    },

    methods: {
      onClickItem(item) {
        if(this.disabled) return;

        const value = this.getItemValue(item);

        if(this.isSelected(value)) this.unselect(value)
        else this.select(value);
      },

      select(value) {
        if(this.multiple) this.$emit('input', [...this.selected, value]);
        else this.$emit('input', value);

        if(this.scrollOnSelect) {
          $('html, body').animate({
            scrollTop: $(document).height(),
          }, 1000);
        }
      },

      unselect(value) {
        if(this.multiple) this.$emit('input', this.selected.filter(v => v !== value));
        else this.$emit('input', null);
      },

      isSelected(value) {
        return this.multiple ?
          this.selected.includes(value) :
          this.selected === value;
      },

      getItemValue(item) {
        return this.itemValue ? item[this.itemValue] : item;
      },
    },

    computed: {
      selected() {
        return this.multiple ?
          (this.value || []) :
          this.value;
      },
    },

    components: {
      Item,
    },
  };
</script>

<style lang="sass" scoped>
  @import '~@/sass/mixins'

  .choices
    $c: &

    &__container
      margin-bottom: 16px

    .choices-item
      margin-bottom: 16px

    &--inline
      #{$c}
        &__container
          +desktop
            display: flex

      .choices-item
        margin: 8px 0

        +desktop
          flex: 1
          margin: 8px

        &:last-child
          margin-right: 0


</style>